import React from "react";
import { ScriptsGrid } from "../components";

const ImagePageSkins = () => {
  return <ScriptsGrid />;
};

export default ImagePageSkins;
